import "./index.css";
import { DuplicateButton } from "../../../../components/DuplicateButton";

const EditableProductComponent = ({
  productNum,
  name,
  setProductNum,
  setName,
  subgroup,
  variationValues,
  customHeight,
}) => {
  const handleDuplicateClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        position: "relative",
        minWidth: "170px",
        width: "fit-content",
        maxWidth: "300px",
        height: customHeight ? customHeight : "210px",
        flexShrink: 0,
      }}
    >
      <div className="product-component-title">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Product name"
          style={{
            width: "100%",
            minWidth: "fit-content",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
          }}
        />
      </div>
      <div
        className="product-component-body"
        style={{
          flex: 1,
          overflow: "hidden",
          wordWrap: "break-word",
          hyphens: "auto",
        }}
      >
        <p
          style={{
            wordWrap: "break-word",
            overflowWrap: "break-word",
            hyphens: "auto",
          }}
        >
          {subgroup || ""}
        </p>
        {variationValues?.length > 0 &&
          variationValues.map((category, categoryIndex) => (
            <div key={`category-${categoryIndex}`}>
              {category?.values?.map((val, valueIndex) => {
                return (
                  val && (
                    <p
                      key={`value-${categoryIndex}-${valueIndex}`}
                      style={{
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                        hyphens: "auto",
                        margin: "2px 0",
                      }}
                    >
                      {typeof val === "string"
                        ? val
                        : val?.value
                        ? val?.value
                        : ""}
                    </p>
                  )
                );
              })}
            </div>
          ))}
      </div>
      <div
        className="product-component-bottom"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
        }}
      >
        <span>#</span>
        <input
          value={productNum}
          onChange={(e) => setProductNum(e.target.value)}
          style={{
            flex: 1,
            minWidth: "60px",
          }}
        />
      </div>

      <DuplicateButton onClick={handleDuplicateClick} />
    </div>
  );
};

export default EditableProductComponent;
